import type { CmsData } from '../types/cmsTypes'

export const getByPath = (obj: CmsData, path: (string | number)[]) => {
  let result: CmsData = obj
  for (const key of path) {
    if (result === null || result === undefined) return {}
    result = result[key] as CmsData
  }
  return result as CmsData
}

const isIndexKey = (key: string | number): boolean => /^\d+$/.test(String(key))

export const setByPath = (obj: CmsData, path: (string | number)[], value: object) => {
  let target: CmsData = obj

  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i] as string
    const nextKey = path[i + 1]
    const needsArray = isIndexKey(nextKey as string | number)

    const existing = target[key]
    const existingIsArray = Array.isArray(existing)
    const existingIsObject = typeof existing === 'object' && existing !== null

    if (!existingIsObject || existingIsArray !== needsArray) {
      target[key] = needsArray ? [] : {}
    }

    target = target[key] as CmsData
  }

  target[path[path.length - 1] as string] = value as CmsData
}
